module.exports = __webpack_public_path__ + "img/conversationVolume.a937c8b1.png";